import { useSelector } from "react-redux";

import { LoadingSpinnerSVG } from "components/SVGIcons";
import { RootState } from "store";
import styles from "./style.module.scss";

export default function LoadingSpinner({ isFetching }: { isFetching?: boolean }) {
  const { isLoading } = useSelector((state: RootState) => state.loaderState);

  return isLoading || isFetching ? (
    <div className={styles.smartSpinnerContainer}>
      <div className={styles.smartSpinnerWrapper}>
        <LoadingSpinnerSVG className={styles.smartSpinner} />
      </div>
    </div>
  ) : null;
}

export const RefLoadingSpinner = ({
  isLoadingMore,
  observerRef
}: {
  isLoadingMore: boolean;
  observerRef?: any;
}) => (
  <div ref={observerRef} className="w-full pb-10 pr-4 h-1">
    <div className="h-10 w-full flex">
      {isLoadingMore && <LoadingSpinnerSVG className={styles.loadMore} />}
    </div>
  </div>
);
